exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-person-button{margin-top:22px;float:none;min-width:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/admin/component/konfigurationView/konfigurationView.scss
// module id = jMwA
// module chunks = 0